import { ThreadItem } from '@/models/thread';
import { createContext } from 'react';

interface ItemContextProps {
  item: ThreadItem;
  isLast: boolean;
}

const ItemContext = createContext<ItemContextProps>({
  item: {
    id: '',
    prompt: '',
    response: [],
    queryDate: new Date(),
    enabledCitation: true,
    sources: [],
    disliked: false,
  },
  isLast: false,
});

export default ItemContext;
